import { createSlice } from '@reduxjs/toolkit'
import baseReducers from 'apiV2/store/base/reducers'
import baseInitialState from 'apiV2/store/base/initialState'

import { indexClosingTasksAPI } from './asyncActions'

const closingTasksSlice = createSlice({
  name: 'closing_task',
  initialState: baseInitialState,
  reducers: baseReducers,
  extraReducers: {
    [indexClosingTasksAPI.pending](state) {
      state.uiFlags.isFetching = true
    },
    [indexClosingTasksAPI.fulfilled](state, action) {
      state.records = action.payload
      state.uiFlags.isFetching = false
    },
    [indexClosingTasksAPI.rejected](state) {
      state.uiFlags.isFetching = false
    },
  },
})

export default closingTasksSlice
